import { render, staticRenderFns } from "./CollapseImg.vue?vue&type=template&id=b3d7f346&scoped=true&"
import script from "./CollapseImg.vue?vue&type=script&lang=js&"
export * from "./CollapseImg.vue?vue&type=script&lang=js&"
import style0 from "./CollapseImg.vue?vue&type=style&index=0&id=b3d7f346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d7f346",
  null
  
)

export default component.exports